<template>
    <div class="mt-5 c_edit_designation_container">
        <div class="profile-nav-bg" style="background-image: url('/images/bg-profile.jpg')"></div>
        <a-card :bordered="false" class="card-apply header-solid h-full widget-1" :bodyStyle="{paddingTop: 0}">
            <template #title>
                <a-row type="flex" align="middle">
                    <a-col :span="48" :md="24" style="display:flex;justify-content:center;margin-bottom:30px">
                        <h5 class="font-semibold m-0">{{$t('designation-update-page.sub-title')}}</h5>
                    </a-col>
                </a-row>
            </template>

            <template>
                <a-form  :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }" @submit="handleSubmit">
                        <!-- :label= "$t('department-update-page.name-en-input-label')" -->
                    <a-form-item 
                        :validate-status="validations.statusName"
                        :help="validations.helpName"
                        style="display:flex;justify-content:center"
                    >
                        <label 
                            class="ml-10" 
                            style="color: #000; font-weight:600"
                        >{{$t('department-create-page.name-en-input-label')}} <b style="color:red">(*)</b>
                        </label>

                        <a-input
                            class="form-input"
                            :placeholder= "$t('department-update-page.name-en-input-placeholder')"
                            v-model="name"
                        />
                    </a-form-item>

                        <!-- :label= "$t('department-update-page.name-bn-input-label')" -->
                    <a-form-item 
                        :validate-status="validations.statusNameBn"
                        :help="validations.helpNameBn"
                        style="display:flex;justify-content:center"
                    >
                        <label 
                            class="ml-10" 
                            style="color: #000; font-weight:600"
                        >{{$t('department-create-page.name-bn-input-label')}} <b style="color:red">(*)</b>
                        </label>

                        <a-input
                            class="form-input"
                            :placeholder= "$t('department-update-page.name-bn-input-placeholder')"
                            v-model="nameBn"
                        />
                    </a-form-item>

                    <a-form-item 
                        style="display:flex;justify-content:center"
                    >   
                        <label 
                            class="ml-10" 
                            style="color: #000; font-weight:600"
                        >{{$t('department-create-page.status-label')}} <b style="color:red">(*)</b>
                        </label>
                            <!-- v-decorator="[
                            'status',
                            { rules: [{ required: true, message: 'Please select your status!' }] },
                            ]" -->
                        <a-select
                            :placeholder= "$t('department-update-page.status-placeholder')"
                            class="form-input"
                            :value="status"
                            @change="onChangeStatusSelection"
                        >
                            <a-select-option v-for="item in $t('dropdown-items.all-status')" :key="item" :value="item">
                                {{ item }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item :wrapper-col="{ span: 12, offset: 6 }">
                        <a-button type="primary" class="mr-10 ml-15 mt-40" html-type="submit">
                            {{$t('designation-update-page.submit-btn-caption')}}
                        </a-button>
                        <a-button type="danger"  @click="navigateTo('Designations')">
                            {{$t('department-create-page.cancel-btn-caption')}}
                        </a-button>
                    </a-form-item>
                </a-form>  
            </template>
        </a-card>
    </div>
</template>

<script>
import { designationsClient } from "../../api/config.js";
import { toastMixin } from "../../mixins/ToastMixin.js";
import { navigationMixin } from "../../mixins/navigation-mixin.js";
export default {
    name: "Edit",
    mixins: [ toastMixin, navigationMixin ],
    data(){
        return {
            allStatus: ["ACTIVE","INACTIVE"],
            name: "",
            nameBn: "",
            status: "",
            parentId: "",
            id: "",
            validations:{
                statusName: "",
                helpName: "",
                statusNameBn: "",
                helpNameBn: "",
            }
        }
    },
    methods:{
        onChangeStatusSelection(e){
            this.status = e;
        },
        clearValidations() {
            Object.keys(this.validations).forEach(key => {
                this.validations[key] = '';
            });
        },
        validate() {
            this.clearValidations();
            if (this.name.trim().length == 0) {
                this.validations.statusName = 'error';
                this.validations.helpName = this.$t('error-message.name');
                return false;
            }
            if (this.nameBn.trim().length == 0) {
                this.validations.statusNameBn = 'error';
                this.validations.helpNameBn = this.$t('error-message.name');
                return false;
            }
            return true;
        },
        handleSubmit(e){
            e.preventDefault();
            console.log(e);
            if (this.validate()){
                console.log(this.name);
                if(this.status == "সক্রিয়" || this.status == "ACTIVE"){
                    this.status = "ACTIVE";
                }
                if(this.status == "নিষ্ক্রিয়" || this.status == "INACTIVE"){
                    this.status = "INACTIVE";
                }
                let submitData = {
                   name : this.name,
                   nameBn : this.nameBn,
                   status: this.status,
                   parentId: this.parentId,
                   id: this.id
                }
                designationsClient.update(submitData).then((res) => {
                    if (!res.networkError){
                        this.successToast(this.$t('toast-success-messages.update-designation'));
                        this.navigateTo("Designations");
                    }
                })
            }
        },
        handleChange(value) {
          console.log(`selected ${value}`);
        },

    },
    watch:{
        '$route.query': {
            immediate: true,
            handler: function(newVal){
                let id = newVal.id;
                // console.log(id);
                designationsClient.fetchDesignationById(id).then(res =>{
                    if(!res.networkError){
                        console.log(res.body);
                        this.name = res.body.name;
                        this.nameBn = res.body.nameBn;
                        // this.status = res.body.status;
                        this.id = res.body.id;
                        if (res.body.status == "ACTIVE"){
                            this.status = this.$t('dropdown-fetch-server-items.active');
                        }else {
                            this.status = this.$t('dropdown-fetch-server-items.inactive');
                        }
                    }
                })

            }
        }
    }
}
</script>

<style>

</style>